<template>
  <div class="profile__actions">
    <ProfileActionButton
      v-for="(action, index) in availableActions"
      :key="index"
      :action="action"
    />
  </div>
</template>

<script>
import LinkShareModalOpener from '@/scripts/libs/social-sharer/LinkShareModalOpener';
import ProfileActionButton from './Shared/ProfileActionButton';

export default {
  components: {
    ProfileActionButton,
  },
  props: {
    user: {
      type: Object,
      default: undefined,
    },
    isOwner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actions: [
        {
          label: this.$t('profile.actions.edit.button'),
          icon: 'fa:pencil',
          url: '/profile/settings',
          action: () => {},
          disabled: !this.isOwner,
        },
        {
          label: this.$t('profile.actions.share.button'),
          icon: 'fa:share-alt',
          action: this.$_shareProfile,
        },
      ],
    };
  },
  computed: {
    availableActions() {
      return this.actions.filter(action => !action.disabled);
    },
    shareOptions() {
      if (!this.user) return {};

      const socialText = this.$t('profile.actions.share.modal.social-body.common', {
        name: this.user.profile.firstName,
      });

      return {
        url: `${window.location.protocol}//${window.location.host}/u/${this.user.profile.vanity}`,
        subject: socialText,
        tweet: socialText,
      };
    },
  },
  methods: {
    $_editProfile() {
      location.href = '/profile/settings';
    },
    $_shareProfile() {
      LinkShareModalOpener.openModal({
        title: this.$t('share.label.share_item', { item: this.$t('profile.label') }),
        message: this.$t('share.label.public_link_of', { item: this.$t('profile.label') }),
      }, this.shareOptions);
    },
  },
};
</script>

<style lang="scss">
.profile__actions {
  min-height: 1em; // Prevent actions from collapsing if no button is rendered
}
</style>
